/* @ngInject */
export default function NotifyingService($rootScope) {
    return {
        subscribe: function (scope, callback) {
            var handler = $rootScope.$on('general-event', callback);
            scope.$on('$destroy', handler);
        },
        notify: function () {
            $rootScope.$emit('general-event');
        },
        // Always handle CacheService.getDefinitionParent() is null. It will be call when user clicks home button.
        subscribeToSleuthChanges: function (scope, callback) {
            var handler = $rootScope.$on('sleuth-change-event', callback);
            scope.$on('$destroy', handler);
        },
        notifySleuthChangeEvent: function () {
            $rootScope.$emit('sleuth-change-event');
        },
        subscribeToMessaging: function (scope, callback) {
            var handler = $rootScope.$on('notify-message-available', callback);
            scope.$on('$destroy', handler);
        },
        messageNotification: function (message) {
            $rootScope.$emit('notify-message-available', message);
        },
        subscribeToCloseMessage: function (scope, callback) {
            var handler = $rootScope.$on('notify-close-message', callback);
            scope.$on('$destory', handler);
        },
        closeMessageNotification: function () {
            $rootScope.$emit('notify-close-message');
        },
        subscribeToRootDefinitionChanges: function (scope, callback) {
            var handler = $rootScope.$on('root-definition-change-event', callback);
            scope.$on('$destroy', handler);
        },
        notifyRootDefinitionChangeEvent: function () {
            $rootScope.$emit('root-definition-change-event');
        },
        subscribeToModelServiceInit: function (scope, callback) {
            var handler = $rootScope.$on('model-service-init-done', callback);
            scope.$on('$destroy', handler);
        },
        notifyModelServiceInit: function () {
            $rootScope.$emit('model-service-init-done');
        },
        subscribeToSleuthDataCache: function (scope, callback) {
            var handler = $rootScope.$on('sleuth-data-cache-done', callback);
            scope.$on('$destroy', handler);
        },
        notifyOfSleuthDataCache: function () {
            $rootScope.$emit('sleuth-data-cache-done');
        },
        subscribeToBuilderFilterAction: function (scope, callback) {
            var handler = $rootScope.$on('builder-filter-action', callback);
            scope.$on('$destroy', handler);
        },
        notifyOfBuilderFilterAction: function () {
            $rootScope.$emit('builder-filter-action');
        },
        subscribeToNullSleuthResult: function (scope, callback) {
            var handler = $rootScope.$on('null-sleuth-result', callback);
            scope.$on('$destroy', handler);
        },
        notifyOfNullSleuthResult: function () {
            $rootScope.$emit('null-sleuth-result');
        }
    };
}
